// Lichte analytics-abstractielaag. Er is bewust GEEN analytics-provider
// hardcoded — trackEvent() logt events naar de dataLayer-conventie zodat
// later Google Tag Manager / Plausible / Fathom / etc. eenvoudig aangesloten
// kan worden. Events worden pas doorgestuurd nadat analytische toestemming
// is gegeven via de cookiebanner (zie site.ts).

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

let consentGiven = false;
const queued: { name: string; payload?: Record<string, unknown> }[] = [];

export function initAnalyticsGate(consent: boolean) {
  consentGiven = consent;
  if (consent) {
    window.dataLayer = window.dataLayer || [];
    for (const evt of queued.splice(0)) {
      window.dataLayer.push({ event: evt.name, ...evt.payload });
    }
  }
}

export function hasAnalyticsConsent() {
  return consentGiven;
}

export function trackEvent(name: string, payload?: Record<string, unknown>) {
  if (!consentGiven) {
    // Bewaar hooguit de laatste paar events in het geheugen tot toestemming
    // gegeven is; geen persistente opslag zonder consent.
    queued.push({ name, payload });
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...payload });
}
